import type { ContractRenewalRequestPayload, ContractRenewalResponse } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useRenewContract(contractId: string, options?: UseMutationOptions<ContractRenewalResponse, unknown, ContractRenewalRequestPayload>) {
  return useMutation(['renew-contract'], ({ startDate }) => {
    const api = getPrivateApi();

    return api.renewContract({ contractId, renewContractRequest: { startDate } });
  }, options);
}